import { IActor, ICategoryData, IStoryData } from 'redhotpie-shared-lib/interfaces/INewFeed';
import * as utils from '../functions/utils';
import owner from './owner';
import { ICategory, IContentItem } from 'redhotpie-shared-lib/interfaces/ICommunity';
import story from './story';

export default class Story {
  id: number | undefined;
  parrentType: string;
  title: string;
  description: string;
  likeCount: number;
  replyCount: number;
  isMemberLike: boolean;
  owner: IActor;
  categories: ICategory[];
  dateCreated: number | string | undefined;
  seoURL?: string;

  constructor() {
    this.id = -1;
    this.parrentType = '';
    this.title = '';
    this.description = '';
    this.likeCount = 0;
    this.replyCount = 0;
    this.isMemberLike = false;
    this.owner = {};
    this.categories = [];
    this.dateCreated = '';
    this.seoURL = '';
  }

  static mappingCategory(_obj: ICategoryData) {
    const obj = {
      value: _obj.Value ? _obj.Value : null,
      text: _obj.Text ? _obj.Text : '',
      isMatch: _obj.IsMatch ? _obj.IsMatch : false,
    };
    return obj;
  }

  static mappingObject(_obj: IStoryData): IContentItem {
    let obj = Object.assign(new Story(), _obj);
    obj.id = _obj.ID || -1;
    obj.parrentType = _obj.ParentType ? _obj.ParentType : '';
    obj.title = _obj.Title ? _obj.Title : '';
    obj.description = _obj.Description ? _obj.Description : '';
    obj.likeCount = _obj.LikeCount || 0;
    obj.replyCount = _obj.ReplyCount || 0;
    obj.isMemberLike = _obj.IsMemberLike ? _obj.IsMemberLike : false;
    obj.owner = _obj.Owner ? owner.mappingObject(_obj.Owner) : {};
    obj.categories = _obj.Categories ? story.mappingCategories(_obj.Categories) : [];
    obj.dateCreated = _obj.DateCreated ? _obj.DateCreated : '';
    obj.seoURL = _obj.SEOUrl || '';

    obj = utils.cleanObjectKeys(Object.keys(new Story()), obj);
    return obj;
  }

  static mappingObjects(_data: IStoryData[]): IContentItem[] {
    return _data.map(item => Story.mappingObject(item));
  }
}
